import { debounce, getCSSVal, getInnerWidth } from "../inc/helpers";

export default class BgCta {
    _sectionPrevEls = [];
    _w = null;
    _el = null;
    _onResize = null;

    constructor() {
        for (const [key, value] of Object.entries(arguments[0]))
            this[`_${key}`] = value;       

        this._setup();
        
        this._onResize = () => this._setup();
        window.addEventListener("resize", debounce(this._onResize));
    }

    _setup() {
        this._w = Array.from(this._sectionPrevEls)?.reduce((sum, el) => sum + el.offsetWidth, 0);
        this._w -= parseFloat(getCSSVal(this._sectionPrevEls?.[0], "paddingLeft"));
        this._w -= parseFloat(getCSSVal(this._sectionPrevEls?.[this._sectionPrevEls?.length - 1], "paddingRight"));
        this._el?.style.setProperty("--cta-w", `${this._w}px`);
    }
}